// homepage search
var client = algoliasearch('ZGGSNUFEL4', '7cf0b412ff5a4f711949334c04f6f738');
var index = client.initIndex('wp_posts_speaker');

//initialize autocomplete on search input (ID selector must match)
autocomplete('#search-input_home', {
	hint: true,
	debug: true
}, {
	source: autocomplete.sources.hits(index, {
		hitsPerPage: 3,
		filters: 'wpml.locale:"' + global.current_locale + '"'
	}),
	templates: {
		suggestion: function (suggestion) {
			return '<a href="' + suggestion.permalink + '"><div class="profile_image" style="background:url(' + suggestion.profile_image + ') center center no-repeat;background-size:cover;">' + '</div><div class="title">' + suggestion._highlightResult.post_title.value + '</div><div class="oneliner">' + suggestion.title + '</div></a>';
		}
	}
});

//initialize autocomplete on search input (ID selector must match)
autocomplete('#search-input_bottom', {
	hint: true,
	debug: true
}, {
	source: autocomplete.sources.hits(index, {
		hitsPerPage: 3,
		filters: 'wpml.locale:"' + global.current_locale + '"'
	}),
	templates: {
		suggestion: function (suggestion) {
			return '<a href="' + suggestion.permalink + '"><div class="profile_image" style="background:url(' + suggestion.profile_image + ') center center no-repeat;background-size:cover;">' + '</div><div class="title">' + suggestion._highlightResult.post_title.value + '</div><div class="oneliner">' + suggestion.title + '</div></a>';
		}
	}
});

if (jQuery('#search-input_overview').length > 0) {
	
	var category = jQuery('.page_category').attr('data-value');
	var topic = jQuery('.page_topic').attr('data-value');
	
	filter_txt = 'wpml.locale:"' + global.current_locale + '"';
	
	if (category.length > 0) {
		filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.speaker_category:"' + category + '"';
	}
	
	if (topic.length > 0) {
		filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.topic:"' + topic + '"';
	}
	
	console.log('filter:' + filter_txt);
	
	// search page overview
	var search = instantsearch({
		// Replace with your own values
		appId: 'ZGGSNUFEL4',
		apiKey: '7cf0b412ff5a4f711949334c04f6f738',
		indexName: 'wp_posts_speaker',
		routing: true,
		searchParameters: {
			hitsPerPage: 15,
			filters: filter_txt
		}
	});
	
	search.addWidget(instantsearch.widgets.searchBox({
		container: '#search-input_overview'
	}));
	
	if (global.current_locale == 'nl_NL') {
		var more_info = 'Meer informatie';
		var read_more = 'Lees verder';
		var results = 'resultaten';
		var no_results = 'Niet alle sprekers en onderwerpen staan op onze website. Neem voor meer informatie en advies contact met ons op via info@speakersacademy.nl.';
	} else {
		var read_more = 'Read more';
		var more_info = 'More information';
		var results = 'results';
		var no_results = "We didn't find any results for the search <em>\"{{query}}\"</em>";
	}
	
	search.addWidget(instantsearch.widgets.infiniteHits({
		container: '#hits',
		cssClasses: {
			root: 'sprekers-container-men overview-page',
			item: 'sprekers-container-men-item',
			active: 'active'
		},
		templates: {
			item: function (data) {
				console.log(data.taxonomies.topic);
				item = '<a href="' + data.permalink + '">';
				item += '<div class="speakers-slide-block" style="background-image: url(' + data.profile_image + ');">';
				item += '<div class="speakers-slide-lang"></div><div class="speakers-slide-data">';
				item += '<div class="speakers-slide-name">' + data.post_title + '</div>';
				item += '<div class="speakers-slide-info"><span>' + data.title + '</span>';
				item += '<div class="speakers-slide-topics">';
				
				var topics = data.taxonomies.topic;
				
				var topic_string = '';
				jQuery.each(topics, function (i, val) {
					topic_string += val + ', ';
					
					if (i == 3) {
						return false;
					}
				});
				
				topic_string = topic_string.slice(0, -2);
				
				item += topic_string + '</div>';
				
				item += '<div class="btn">' + more_info + '</div></div></div></div></a>';
				
				return item;
			},
			empty: no_results
		},
		escapeHits: false,
		showMoreLabel: 'Toon meer sprekers'
	}));
	
	search.addWidget(instantsearch.widgets.refinementList({
		container: '#category-refinement',
		attributeName: 'taxonomies.speaker_category',
		cssClasses: {
			root: 'icheck-inp-overzitcht'
		}
	}));
	
	search.addWidget(instantsearch.widgets.refinementList({
		container: '#topic-refinement',
		attributeName: 'taxonomies.topic',
		limit: 999,
		cssClasses: {
			root: 'icheck-inp-overzitcht'
		}
	}));
	
	search.addWidget(instantsearch.widgets.refinementList({
		container: '#languages-refinement',
		attributeName: 'taxonomies.languages',
		cssClasses: {
			root: 'icheck-inp-overzitcht'
		}
	}));
	
	search.addWidget(instantsearch.widgets.refinementList({
		container: '#employability-refinement',
		attributeName: 'taxonomies.employability',
		RefinementListItemData: {
			count: false
		},
		cssClasses: {
			root: 'icheck-inp-overzitcht'
		}
	}));
	
	search.addWidget(instantsearch.widgets.refinementList({
		container: '#gender-refinement',
		attributeName: 'gender',
		cssClasses: {
			root: 'icheck-inp-overzitcht'
		},
		templates: {
			item: function (e) {
				
				if (global.current_locale == 'nl_NL') {
					if (e.label == 'male') {
						value = 'Man';
					} else {
						value = 'Vrouw';
					}
				} else {
					value = e.label;
				}
				
				value = '<label>' + value + '</label>';
				
				return value;
			},
		},
	}));
	
	search.addWidget(instantsearch.widgets.numericRefinementList({
		container: '#price',
		attributeName: 'price',
		operator: 'or',
		autoHideContainer: true,
		options: [{name: 'Alles'}, {
			start: 500,
			end: 1000,
			name: '500 tot 1.000'
		}, {
			start: 1000,
			end: 2000,
			name: '1.000 tot 2.000'
		}, {
			start: 2000,
			end: 3000,
			name: '2.000 tot 3.000'
		}, {
			start: 3000,
			end: 4000,
			name: '3.000 tot 4.000'
		}, {
			start: 4000,
			end: 5000,
			name: '4.000 tot 5.000'
		}, {
			start: 5000,
			end: 7500,
			name: '5.000 tot 7.500'
		}, {
			start: 7500,
			end: 15000,
			name: '7.500 tot 15.000'
		}, {
			start: 15000,
			end: 25000,
			name: '15.000 tot 25.000'
		}, {
			start: 25000,
			name: '25.000 en meer'
		}]
	}));
	
	search.addWidget(instantsearch.widgets.clearAll({
		container: '#clear-all',
		templates: {
			link: 'Wis filters'
		},
		autoHideContainer: false,
		clearsQuery: true,
	}));
	
	search.start();
	
	////////// blogs and videos search
	var category = jQuery('.page_category').attr('data-value');
	var topic = jQuery('.page_topic').attr('data-value');
	
	filter_txt = 'wpml.locale:"' + global.current_locale + '"';
	
	if (category.length > 0) {
		filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.speaker_category:"' + category + '"';
	}
	
	if (topic.length > 0) {
		filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.topic:"' + topic + '"';
	}
	
	// search page overview
	var blog_search = instantsearch({
		// Replace with your own values
		appId: 'ZGGSNUFEL4',
		apiKey: '7cf0b412ff5a4f711949334c04f6f738',
		indexName: 'wp_posts_post',
		routing: true,
		searchParameters: {
			hitsPerPage: 5,
			filters: filter_txt
		}
	});
	
	
	blog_search.on('render', function () {
		if (!jQuery('#blogs_news .ais-infinite-hits--item').length) {
			jQuery('.overview-blog').hide();
		}
		
		jQuery('.liquid').imgLiquid();
		jQuery('.blog-news-short').matchHeight();
	});
	
	blog_search.addWidget(instantsearch.widgets.searchBox({
		container: '#search-input_overview'
	}));
	
	if (global.current_locale == 'nl_NL') {
		var more_info = 'Meer informatie';
		var results = 'resultaten';
	} else {
		var more_info = 'More information';
		var results = 'results';
	}
	
	blog_search.addWidget(instantsearch.widgets.infiniteHits({
		container: '#blogs_news',
		cssClasses: {
			root: '',
			item: '',
			active: 'active'
		},
		templates: {
			item: function (data) {
				console.log(data);
				item = '';
				if (data.__hitIndex < 2) {
					item += '<div class="blog-news-item2">';
					item += '<div class="blog-news-big-short';
					
					if (data.video.length > 0) {
						item += ' video ';
					}
					
					item += ' liquid">';
					item += data.item_image;
					item += '<div class="blog-n-b-s-info">';
					item += '<span>' + data.formated_date + '</span>';
					item += '<h3>' + data.post_title + '</h3>';
					item += '<p>' + data.content_short + '...</p>';
					item += '</div>';
					item += '<a href="' + data.permalink + '"></a>';
					item += '</div></div>';
					
				} else {
					item += '<div class="blog-news-item">';
					item += '<div class="blog-news-short" data-mh="blog-short-box">';
					item += '<h3 data-mh="blog-short-title">' + data.post_title + '</h3>';
					item += '<p>' + data.content_short + '...</p>';
					item += '<span>' + read_more + '</span>';
					item += '<a href="' + data.permalink + '"></a>';
					item += '</div>';
					item += '</div>';
				}
				
				return item;
			},
			empty: ''
		},
		escapeHits: false,
		showMoreLabel: 'Toon meer items'
	}));
	
	blog_search.start();
	
}